import { reject } from 'ramda'
import { AcquiringOrder, Params } from 'app/dataTypes/acquiring/order'

import type { Request } from '../../../index'

type ApiParams = {
  service: 'primary' | 'cafeteria' | 'camp'
  sum: string
  accountable_id: number
  accountable_type: 'Parent' | 'Student'
  success_url?: string
  failure_url?: string
  recurrent_save?: 1
  saved_bank_card_id?: number
}

type ApiResult = {
  id: number
  pay_url: string
}

export const convertParams = ({
  id,
  ownerType,
  refillType,
  amount,
  successURL,
  failureURL,
  recurrentSave,
  recurrentCardId,
}: Params): [ApiParams, null] => {
  return [
    reject<any, any>((value) => value === undefined, {
      accountable_id: parseInt(id, 10),
      accountable_type: ownerType,
      service: refillType,
      sum: String(amount),
      success_url: successURL || undefined,
      failure_url: failureURL || undefined,
      recurrent_save: recurrentSave ? 1 : undefined,
      saved_bank_card_id: recurrentCardId ? parseInt(recurrentCardId, 10) : undefined,
    } satisfies ApiParams),
    null,
  ]
}

export const convertResult = ({ id, pay_url: payURL }: ApiResult): AcquiringOrder => {
  return {
    ID: String(id),
    payURL,
  }
}

export const POST_ACQUIRING_ORDERS: Request<Params, AcquiringOrder, void> = [
  'payments/acquiring2/orders',
  'post',
  ['data'],
]
